import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainEstimacionesReportePenasConvencionales',
  components: {
  },
  mixins: [mixAvanceProgramado, mixGenerarPdf, mixFormatoEstructura],
  data() {
    return {
      tipo: 'baseDias',
      importeProgramadoEstaEstimacion: 0,
      importeEjecutadoEstaEstimacion: 0,
      importeAtrasoEstaEstimacion: 0,
      porcentajeRetencion: (this.contrato.porcentajeRetencion / 100),
      importeRetenidoAnteriormente: 0,
      importeRetencionAplicarEstaEstimacion: 0,
      importeDevolucionEstaEstimacion: 0,
      porcentajeSancion: (this.contrato.porcentajeSancion / 100),
      porcentajeDeSacionEtiqueta: this.contrato.porcentajeSancion,
    };
  },
  mounted() {
    this.calcular();
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfPenasConvencionales() {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, []);

      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const conveniosConFormato = this.formatoObjeto(this.listadoConvenios);
      const supervisor = this.getSupervisorEnPenasConvencionales || '';
      // const firmasFuncionarios = this.firmas;
      const datosCalculados = {
        tipo: this.tipo,
        diasTranscuridos: this.getProgramaEnPenasConvencionales.diasTranscuridos,
        importeDelContrato: this.importeDelContratoEnPenasConvencionales,
        importeProgramadoEstaEstimacion: this.importeProgramadoEstaEstimacion,
        importeEjecutadoEstaEstimacion: this.importeEjecutadoEstaEstimacion,
        montoDiarioProgramado: this.montoDiarioProgramado,
        diasEjecutadosReales: this.diasEjecutadosReales,
        diasDeDesfazamiento: this.diasDeDesfazamiento,
        montoDeAtraso: this.montoDeAtraso,
        porcentajeRetencion: (this.porcentajeRetencion * 100),
        importeRetencionEstaEstimacion: this.importeRetencionEstaEstimacion,
        importeRetenidoAnteriormente: this.importeRetenidoAnteriormente,
        montoFueraPrograma: this.montoFueraPrograma,
        diasDeAtraso: this.diasDeAtraso,
        porcentajeSancion: this.porcentajeSancion,
        sancionAplicarEstaEStimacion: this.sancionAplicarEstaEStimacion,
        sumaSancionesAnteriores: this.sumaSancionesAnteriores,
        importeAtrasoEstaEstimacion: this.importeAtrasoEstaEstimacion,
        seccionRetencionSancion: this.seccionRetencionSancion,
        tieneConvenios: this.listadoConvenios.length ? this.listadoConvenios.length : 0,
      };
      const datos = this.formatoObjeto(datosCalculados);
      const nombreTemplate = 'templatePenasConvencionales';
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          convenios: conveniosConFormato,
          supervisor,
          firmas: '',
          datos,
          footer: '',
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_PenasConvencionales_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },

    calcular() {
      this.importeProgramadoEstaEstimacion = this.estimacion.importeMontoProgramado;
      this.importeEjecutadoEstaEstimacion = this.acumuladoTotalEnPenasConvencionales;
      this.importeAtrasoEstaEstimacion = this.importeProgramadoEstaEstimacion
        - this.importeEjecutadoEstaEstimacion;
      this.importeRetenidoAnteriormente = this.importeTotalRetenidoAnteriormente;
    },
  },
  computed: {
    importeRetencionEstaEstimacion() {
      if (this.estimacion.esEstimacionFiniquito) return 0;

      return (this.montoDeAtraso * (this.porcentajeRetencion));
    },
    importeDelContratoEnPenasConvencionales() {
      return this.estimacion.importeContratoSinFinanciamiento;
    },
    numeroEstimacionEnPenasConvencionales() {
      return Number(this.estimacion.numero);
    },
    getProgramaEnPenasConvencionales() {
      return this.mixCalcularPrograma(this.estimacion.fechaAl);
    },
    montoDiarioProgramado() {
      const { diasTranscuridos } = this.getProgramaEnPenasConvencionales;
      return (this.estimacion.importeMontoProgramado / diasTranscuridos);
    },
    diasEjecutadosReales() {
      return Math.floor((this.importeEjecutadoEstaEstimacion / this.montoDiarioProgramado));
    },
    diasDeDesfazamiento() {
      const { diasTranscuridos } = this.getProgramaEnPenasConvencionales;
      const diasDesfasamiento = (diasTranscuridos - this.diasEjecutadosReales);
      if (diasDesfasamiento < 0) return 0;
      return diasDesfasamiento;
    },
    montoDeAtraso() {
      if (this.estimacion.esEstimacionFiniquito) return 0;
      const monto = (this.diasDeDesfazamiento * this.$numberRound(this.montoDiarioProgramado));
      if (monto < 0) return 0;
      return monto;
    },
    estimacionesAnterioresEnPenasConvencionales() {
      return this.estimaciones.filter(
        ({ numero }) => Number(numero) < this.numeroEstimacionEnPenasConvencionales,
      );
    },
    estimadoAcumuladoAnterirorEnPenasConvencionales() {
      return this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeEstimado');
    },
    acumuladoTotalEnPenasConvencionales() {
      if (!this.estimacion.importeEstimado) return 0;
      return this.estimacion.importeEstimado + this.estimadoAcumuladoAnterirorEnPenasConvencionales;
    },
    importeTotalRetenidoAnteriormente() {
      const retenidoAnterior = this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeRetenido');
      const retenidoDevuelto = this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeDevuelto');
      return (retenidoAnterior - retenidoDevuelto);
    },
    importeRetencionNetaAplica() {
      const importe = this.importeRetencionEstaEstimacion - this.importeTotalRetenidoAnteriormente;
      if (importe <= 0) return 0;
      return importe;
    },
    ordenarListadoFirmasEnPenasConvencionales() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden);
    },
    estimacionesDentroPrograma() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);

      if (!estimacionFinPrograma) return [];

      return this.estimaciones
        .filter(
          ({ numero }) => Number(numero) <= Number(estimacionFinPrograma.numero),
        );
    },
    montoFueraPrograma() {
      const montoAnterior = this.$ObjSumar(this.estimacionesDentroPrograma, 'importeEstimado');

      if (this.estimacion.esEstimacionFiniquito) {
        return (this.importeEjecutadoEstaEstimacion - montoAnterior);
      }
      return (this.importeDelContratoEnPenasConvencionales - montoAnterior);
    },
    diasDeAtraso() {
      const { fechaTermino: fechaTerminoPrograma } = this
        .mixGetPrograma[this.mixGetPrograma.length - 1];
      const fechaTerminoEstimacion = this.estimacion.fechaAl;
      return this.calcularDiferenciaEnDias(fechaTerminoPrograma, fechaTerminoEstimacion) - 1;
    },
    sumaSancionesAnteriores() {
      return this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeSancion');
    },
    sancionAplicarEstaEStimacion() {
      const importeDeAtraso = this.montoFueraPrograma * this.diasDeAtraso;
      return importeDeAtraso * (this.porcentajeSancion);
    },
    getSupervisorEnPenasConvencionales() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    seccionRetencionSancion() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);

      if (!this.estimacion.numero) return '';

      if (!estimacionFinPrograma || estimacionFinPrograma.numero
      >= this.estimacion.numero) { return 'retencion'; }
      return 'sancion';
    },
    listadoConvenios() {
      if (!this.contrato.convenios) return [];
      return this.contrato.convenios
        .filter((c) => c.fecha <= this.estimacion.fechaAl)
        .filter((c) => c.tipo.includes('PLAZO') || c.tipo.includes('MONTO'))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },
  },
  watch: {
    estimacion: {
      handler() {
        // this.calcular();
      },
    },
  },
};
